import { Modal, type ModalProps } from "antd"
import { H7 } from "components/typography/H7"

interface Props extends Omit<ModalProps, "title" | "footer"> {
  className?: string
  title?: string
  subTitle?: string
  onClose: Function
  children: JSX.Element | JSX.Element[]
  useBgColor?: boolean
}

export const ModalWrapper: React.FC<Props> = ({
  className,
  onClose,
  children,
  title,
  subTitle,
  useBgColor = false,
  ...rest
}) => {
  return (
    <Modal
      title={
        title ? (
          <div className="px-4 md:px-6 p-4 border-b">
            <H7 className={"font-medium text-neutral600"}>{title}</H7>

            <p className={"text-neutral100 text-sm font-light mt-2"}>
              {subTitle}
            </p>
          </div>
        ) : null
      }
      wrapClassName="[&_.ant-modal-content]:!p-0"
      footer={null}
      open={true}
      onCancel={(e) => {
        e.preventDefault()
        onClose?.()
      }}
      {...rest}
    >
      <div>{children}</div>
    </Modal>
  )
}
